import styled from 'styled-components';
import {Grid, Paper} from "@material-ui/core";
import TooltipDefault from "../../../Components/TooltipComponent/TololtipDefault";

export const CardUserDetailsStyled = styled(Paper)`
    min-width: 300px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    height: fit-content;
`;

export const CardUserDetailsDivStyled = styled.div`
    display: flex;
    flex-direction: column;
`;


export const CardUserDetailsPaperStyled = styled(Paper)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
`;

export const MainContentStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

export const CardUserDetailsLeftStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
`;

export const TotalizadorContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    align-items: center;
`;

export const CardUserDetailsDividerStyled = styled.div`
    height: 100%;
    border-color: gray;
    border-style: solid;
`;

export const ImgFidelityStyled = styled.div`
    position: relative;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border-style: solid;
    border-color: ${'#' + process.env.REACT_APP_SECONDARY_COLOR};

    img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
    }
`;

export const ContentFidelityStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const DivWithPaddingStyled = styled.div`
    padding: 10px;
`;

export const ContentAddressStyled = styled.div`
    padding-left: 10px;
    display: flex;
    flex-direction: column;
`;

export const ContentButtonModalStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: right;
`;

//Table

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin: 20px 0;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: sans-serif;
  background-color: white;
`;

export const Th = styled.th`
  background-color: #f4f7f6;
  color: #333;
  text-align: left;
  padding: 12px 15px;
  border-bottom: 2px solid #ddd;
  text-transform: uppercase;
  font-size: 12px;
`;

export const Td = styled.td`
  padding: 12px 15px;
  border-bottom: 1px solid #eee;
  color: #555;
  font-size: 14px;

  /* Estilo para valores nulos ou vazios */
  span.empty {
    color: #ccc;
    font-style: italic;
  }
`;

export const StatusBadge = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  background-color: ${props => props.active ? '#ffebee' : '#e8f5e9'};
  color: ${props => props.active ? '#c62828' : '#2e7d32'};
`;


